import moment from "moment";

export default function niceDate(
  date,
  locale,
  showTime = false,
  fullDate = false,
  correctOffset = false
) {
  if (date) {
    // important - we always have local time here, so we use UTC hours for output and set the zone through setZone
    const d = moment(date);
    d.locale(locale);

    // subtract offset
    if (correctOffset) d.subtract(d.utcOffset(), "m");

    return d.format(fullDate ? "LL" : showTime ? "LT" : "L");
  }
}
